var _a;
import React, { useCallback } from "react";
import { useSelector } from "react-redux";
// components
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
// helpers
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
// types
import { clientTiericons, EClientTier, } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
import * as URLConfig from "@frameworks/salesjourney/config/domain";
import actions from "@mainDi/features/AIF-PMS/actions";
var tierBorderClasses = (_a = {},
    _a[EClientTier.DIAMOND] = "border-dark-orchid",
    _a[EClientTier.BLACK] = "border-black",
    _a[EClientTier.PLATINUM] = "border-wild-blue-yonder",
    _a[EClientTier.GOLD] = "border-golden-rod1",
    _a[EClientTier.SILVER] = "border-quick-silver1",
    _a[EClientTier.BRONZE] = "border-coconut",
    _a[EClientTier.BLUE] = "border-blue-de-france",
    _a);
function ClientDetails(_a) {
    var _b, _c, _d;
    var _e = _a.footer, footer = _e === void 0 ? true : _e, _f = _a.className, className = _f === void 0 ? "" : _f, setLeadId = _a.setLeadId, setIsCxoButtonEnabled = _a.setIsCxoButtonEnabled;
    //
    var cActions = actions();
    var _g = useSelector(function (state) { return state.markets.AifPms; }), clientDetails = _g.clientDetails, transactionId = _g.transactionId;
    var searchParams = new URLSearchParams(location.search);
    var handleNavigate = useCallback(function () {
        localStorage.setItem("client360SelectedClient", JSON.stringify(clientDetails));
        var path = "".concat(URLConfig.config.applicationRoot, "clientdetails/overview?link=").concat(clientDetails.isPartner ? "profile" : "overview");
        window.open(path, "_BLANK");
    }, [clientDetails]);
    var onClickEdit = function (e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        if (!searchParams.get("ucc") && !searchParams.get("categoryCode")) {
            aifPmsDi.aifPms.updateClientDetails(null);
            cActions.leadservice.selectLoginSearchData(null);
            setLeadId && setLeadId(false);
            setIsCxoButtonEnabled && setIsCxoButtonEnabled(false);
        }
    };
    function getBorderClass(tier) {
        return tierBorderClasses[tier] || "";
    }
    var onClickUccEdit = function (e) {
        e.stopPropagation();
        if (transactionId <= 0) {
            aifPmsDi.aifPms.updateClientDetails(null);
            setLeadId && setLeadId(false);
            cActions.leadservice.selectLoginSearchData(null);
            setIsCxoButtonEnabled && setIsCxoButtonEnabled(false);
        }
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "d-flex gap-3 p-bottom-24 aif-pms-genericScheme-sec justify-content-between  ".concat(className, " ").concat((clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.clienttier) ? "ger-sheme" : "", " ") },
            React.createElement(GenericSchemeName, { name: clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.clientName, subText1: clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.ucccode, subText2: clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.pan, maxWidth: 305, showTooltip: true, showImage: true, wrap: true, clickHandlerConfig: {
                    iconClickConfig: {
                        className: getBorderClass((_b = clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.clienttier) === null || _b === void 0 ? void 0 : _b.toLowerCase()),
                    },
                    schemeNameClickConfig: {
                        className: "",
                        onClickHandler: handleNavigate,
                    },
                }, parentClassName: "icon-text-container icon-tier-border-color", badgeIcon: (clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.clienttier) &&
                    Object.keys(clientTiericons).includes((_c = clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.clienttier) === null || _c === void 0 ? void 0 : _c.toLowerCase())
                    ? clientTiericons[(_d = clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.clienttier) === null || _d === void 0 ? void 0 : _d.toLowerCase()]
                    : "" }),
            !searchParams.get("ucc") && !searchParams.get("categoryCode") ? (React.createElement("i", { onClick: onClickUccEdit, className: "d-flex justify-content-center align-items-center text-han-blue mt-1 edel-icon-editicon-underline cursor-pointer ".concat(transactionId > 0 && "btn-disabled", " ") })) : (React.createElement("i", { onClick: onClickEdit, className: "d-flex justify-content-center align-items-center text-han-blue mt-1 edel-icon-editicon-underline cursor-pointer ".concat(searchParams.get("ucc") &&
                    searchParams.get("categoryCode") &&
                    "btn-disabled") }))),
        footer && React.createElement("div", { className: "client-details" })));
}
export default ClientDetails;
